import { render, staticRenderFns } from "./CurrentAssets.vue?vue&type=template&id=496699f4&scoped=true&"
import script from "./CurrentAssets.vue?vue&type=script&lang=js&"
export * from "./CurrentAssets.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAssets.vue?vue&type=style&index=0&id=496699f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496699f4",
  null
  
)

export default component.exports